







































































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import UserGoal from '../../../api/v2/models/user_goal'
import ChartProgress from './ChartProgress.vue'
import { format } from 'date-fns'
import { checkMobile } from '../../utils/utils'

@Component({
  components: {
    ChartProgress
  }
})
export default class GoalSummary extends Vue {
  @Prop({ required: true })
  userGoal: UserGoal

  mobile = checkMobile()

  dateFormat(date: string, formatDate: string = 'MM/DD') {
    return format(date, formatDate)
  }

  get isLate() {
    return this.userGoal.daysRemaining <= 0 && this.userGoal.progressRate < 100
  }

  get isOnSchedule() {
    return this.userGoal.daysRemaining > 0 && this.userGoal.progressRate < 100
  }
}
